import { render, staticRenderFns } from "./SliderFormGroup.vue?vue&type=template&id=2240fc72"
import script from "./SliderFormGroup.vue?vue&type=script&lang=js"
export * from "./SliderFormGroup.vue?vue&type=script&lang=js"
import style0 from "./SliderFormGroup.vue?vue&type=style&index=0&id=2240fc72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports